<div class="alert" [ngClass]="classes" role="alert">
    {{message}}
</div>
